import { ReactNode } from 'react';
import { AppliedAdminReviewStatus, BiometricResidencePermitDoc, RefusalGrounds } from 'api-paths-cas';

export enum Q {
  LEGAL_ADVICE_DISCLAIMER = 'legalAdviseDisclaimer',
  INFO_PROCESSING = 'infoProcessing',
  EMAIL = 'email',
  GIVEN_NAME = 'givenName',
  MIDDLE_NAME = 'middleName',
  SURNAME = 'surname',
  HAS_OTHER_NAMES = 'hasOtherNames',
  OTHER_NAMES = 'otherNames',
  OTHER_NAME_SURNAME = 'otherNameSurname',
  OTHER_NAME_GIVEN_NAME = 'otherNameGivenName',
  OTHER_NAME_REASON = 'otherNameReason',
  DOB = 'dob',
  PHONE_NUMBER = 'phoneNumber',
  NATIONALITY = 'nationality',
  HAS_OTHER_NATIONALITY = 'hasOtherNationality',
  OTHER_NATIONALITIES = 'otherNationalities',
  OTHER_NATIONALITIES_IS_CURRENT = 'otherNationalitiesCurrent',
  GENDER = 'gender',
  ADDRESS = 'homeAddress',
  HOME_ADDRESS = 'homeAddress',
  POSTCODE = 'postCode',
  CITY = 'city',
  COUNTRY = 'country',
  BIRTH_COUNTRY = 'birthCountry',
  HAS_CRIMINAL_CONVICTIONS = 'hasCriminalConvictions',
  CRIMINAL_CONVICTIONS_REASON = 'criminalConvictionReason',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  START_DATE_MANUAL = 'startDateManual',
  COURSES = 'courses',
  STUDENT_NUMBER = 'studentNo',
  COURSE_LEVEL = 'courseLevel',
  COURSE_OFFER_EVIDENCE = 'offerEvidence',
  COURSE_LEVEL_OTHER = 'courseLevelOther',
  COURSE_NAME = 'courseName',
  COURSE_NAME_MANUAL = 'courseNameManual',
  CAH3_CODE = 'CAH3',
  CAH3_CODE_MANUAL = 'CAH3Manual',
  HAS_WORK_PLACEMENT = 'hasWorkPlacement',
  PASSPORT_NUMBER = 'passportNumber',
  PASSPORT_STATUS = 'passportStatus',
  PASSPORT_EXPIRY = 'passportExpiryDate',
  PASSPORT_EXPECTED = 'passportExpectedDate',
  AGENT = 'withAgent',
  SOMEONE_ELSE_NAME = 'someoneElseName',
  VISA_SUPPORT = 'visaSupport',
  IS_COUNTRY_OF_NATIONALITY = 'applyingFromHomeCountry',
  LIVED_IN_UK_LAST_12_MONTHS = 'livedInUKLast12Months',
  COUNTRY_OF_VISA_APPLICATION = 'countryOfVisaApplication',
  REASON_WHY_NOT_COUNTRY_OF_NATIONALITY = 'otherCountryReason',
  HAS_ENGLISH_TEST = 'hasEnglishTest',
  ENGLISH_TEST_TYPE = 'englishTestType',
  ENGLISH_TEST_TYPE_OTHER = 'englishTestTypeOther',
  QUALIFICATION = 'qualification',
  QUALIFICATION_OTHER = 'qualificationOther',
  ENGLISH_TEST_NOT_REQD_REASON = 'englishTestNotReqdReason',
  ENGLISH_TEST_NOT_REQD_REASON_OTHER = 'englishTestNotReqdReasonOther',

  LAST_COURSE = 'lastCourse',
  LAST_COURSE_OTHER = 'lastCourseOther',
  LAST_COURSE_YEAR = 'lastCourseYear',
  HAS_OVERSEAS_TRAVEL = 'hasOverseasTravel',
  OVERSEAS_TRAVEL_TIMES = 'overseasTravelTimes',
  HAS_UK_TRAVEL = 'hasUkTravel',
  UK_TRAVEL_TIMES = 'ukTravelTimes',
  HAS_PREVIOUS_UK_STUDY = 'hasPreviousUkStudy',
  HAS_PREVIOUS_UK_STUDY_VISA = 'hasPreviousUkStudyVisa',
  PREVIOUS_UK_VISAS = 'previousUkStudyVisas',
  LAST_COURSE_LEVEL = 'lastCourseLevel',
  REASON_WHY_LOWER_OR_SAME_LEVEL = 'lowerOrSameLevelReason',
  UK_LEAVE_TO_REMAIN = 'hasLeaveToRemain',
  PREVIOUS_VISA_REJECTION = 'hasBorderRefusal',
  PREVIOUS_VISA_REJECTION_REASON = 'borderRefusalReason',
  PREVIOUS_UK_STUDY_TYPE = 'visaType',
  PREVIOUS_UK_STUDY_LEVEL_OF_STUDY = 'level',
  PREVIOUS_UK_STUDY_YEAR_OF_RECEIVED = 'year',
  PREVIOUS_UK_STUDY_IS_COURSE_COMPLETE = 'isComplete',
  PREVIOUS_UK_STUDY_REASON_WHY_NOT_COMPLETE_COURSE = 'incompleteReason',
  PREVIOUS_UK_STUDY_IS_INCOPLETE_RECORDED = 'isIncompleteRecorded',
  PREVIOUS_UK_STUDY_IS_VISA_SHORTENED = 'isVisaShortened',
  PREVIOUS_UK_STUDY_DATE_VISA_SHORTENED = 'shortenedDate',
  PREVIOUS_UK_VISA = 'visa',

  PREV_UK_OTHER_VISA = 'hasOtherUkVisas',
  PREV_UK_OTHER_VISAS = 'otherUkVisas',
  PREV_UK_OTHER_VISA_TYPE = 'prev_uk_other_visa_type',
  PREV_UK_OTHER_VISA_YEAR = 'prev_uk_other_visa_year',
  PREV_VISA_REFUSAL = 'hasUkVisaRefusals',
  PREV_VISA_REFUSALS = 'ukVisaRefusals',
  PREV_VISA_REFUSAL_TYPE = 'prev_visa_refusal_type',
  PREV_VISA_REFUSAL_YEAR = 'prev_visa_refusal_year',
  PREV_VISA_REFUSAL_DATE = 'prev_visa_refusal_date',
  PREV_NON_UK_VISA_REFUSAL = 'hasOtherVisaRefusals',
  PREV_NON_UK_VISA_REFUSALS = 'otherVisaRefusals',
  PREV_NON_UK_VISA_REFUSAL_COUNTRY = 'prev_non_uk_visa_country',
  PREV_NON_UK_VISA_REFUSAL_IS_STUDENT_VISA = 'prev_non_uk_visa_is_student_visa',
  PREV_NON_UK_VISA_REFUSAL_YEAR = 'prev_non_uk_visa_refusal_year',

  FAMILY_MEMBERS_TRAVELLING = 'hasDependents',
  SPOUSE_TRAVELLING = 'hasPartner',
  PARTNER_VISA_STATUS = 'partnerVisaStatus',
  CHILDREN_TRAVELLING = 'hasChildren',
  CHILDREN_TRAVELLING_NUMBER = 'childrenNum',
  COURSE_FEE_DEPOSIT_REQD = 'courseFeeDepositReqd',
  COURSE_FEE_DEPOSIT = 'courseFeeDeposit',
  COURSE_FEE_DEPOSIT_DATE = 'courseFeeDepositDate',
  COURSE_FEE_DEPOSIT_NOT_REQD_REASON = 'courseFeeDepositNotReqdReason',
  ACCOMMODATION_DEPOSIT_REQD = 'accomDepositReqd',
  ACCOMMODATION_DEPOSIT = 'accomDeposit',
  ACCOMMODATION_DEPOSIT_DATE = 'accomDepositDate',
  CAS_RECEIVED = 'casReceived',
  CONSENTS_1 = 'consents1',
  CONSENTS_2 = 'consents2',
  CONSENTS_3 = 'consents3',
  CONSENTS_4 = 'consents4',
  WHY_UK = 'whyUk',
  WHY_UK_OTHER = 'whyUkOther',
  SELECTED_COURSE_REASONS = 'selectedCourseReasons',
  SELECTED_COURSE_REASONS_OTHER = 'selectedCourseReasonsOther',
  SELECTED_UNI_REASONS = 'selectedUniReasons',
  SELECTED_UNI_REASONS_OTHER = 'selectedUniReasonsOther',
  UNI_CHOICE_REASON_1 = 'uniChoiceReason1',
  UNI_CHOICE_REASON_2 = 'uniChoiceReason2',
  UNI_CHOICE_REASON_3 = 'uniChoiceReason3',
  CAMPUS = 'campus',
  CAMPUS_MANUAL = 'campusManual',
  CAMPUS_PRE_CAS = 'campusPreCas',
  CONSIDER_OTHER_UNI = 'considerOtherUni',
  OTHER_UNI_1 = 'otherUni1',
  OTHER_UNI_2 = 'otherUni2',
  SELECTED_RESEARCH_METHODS = 'selectedResearchMethods',
  SELECTED_RESEARCH_METHODS_OTHER = 'selectedResearchMethodsOther',
  WHY_NOT_OTHER_UNI = 'whyNotOtherUni',
  CONSIDER_OTHER_COURSES = 'considerOtherCourses',
  CONSIDER_OTHER_COURSE = 'considerOtherCourse',
  WHY_NOT_CONSIDER_OTHER_COURSE = 'whyNotConsiderOtherCourse',
  COURSE_ALIGN_FUTURE_CAREER = 'courseAlignFutureCareer',
  COURSE_ALIGN_FUTURE_CAREER_OTHER = 'courseAlignFutureCareerOther',
  WORK_WHILE_STUDY = 'workWhileStudy',
  MAX_WORK_HOURS_PER_WEEK = 'maxWorkHoursPerWeek',
  WHY_WORK_WHILE_STUDY = 'whyWorkWhileStudy',
  WHY_WORK_WHILE_STUDY_OTHER = 'whyWorkWhileStudyOther',
  AFFORD_COURSE_AND_LIVING_WITHOUT_WORKING = 'affordCourseAndLivingWithoutWorking',
  AFFORD_COURSE_AND_LIVING_WITHOUT_WORKING_NO = 'affordCourseAndLivingWithoutWorkingNo',
  COMPLETE_DEGREE_WORK_COUNTRY = 'completeDegreeWorkCountry',
  EXPECTED_SALARY = 'expectedSalary',
  FURTHER_STUDY_IN_UK = 'furtherStudyInUk',
  FURTHER_STUDY_CAREER_PLANS = 'furtherStudyCareerPlans',
  LIVE_WHILE_STUDYING = 'liveWhileStudying',
  LIVE_WHILE_STUDYING_OTHER = 'liveWhileStudyingOther',
  EXPECTED_WEEKLY_RENT = 'expectedWeeklyRent',
  COMMUTE_PLAN = 'commutePlan',
  EXPECTED_LIVING_EXPENSES = 'expectedLivingExpenses',
  AWARE_OF_UK_VI_INTERVIEW = 'awareOfUKVIInterview',
  LIVING_COST = 'livingCost',
  COURSE_FEE = 'courseFee',
  COURSE_SCHOLARSHIP_AMOUNT1 = 'courseScholarshipAmount1',
  FEE_AFTER_SCHOLARSHIP = 'feeAfterScholarships',
  INNER_LONDON = 'innerLondon',
  COURSE_NOT_LISTED = 'courseNotListedOrResearchStudent',
  USE_WHATSAPP = 'useWhatsapp',
  WHATSAPP_OTHER_NUMBER = 'whatsAppPhoneNumber',
}

export enum UserRole {
  Admin = '[Admin]',
  UniAdmin = '[UniAdmin]',
  Uni = '[Uni]',
  UniSecure = '[UniSecure]',
  UniLite = '[UniLite]',
  Agent = '[Agent]',
  Enroly = '[Enroly]',
  AgencyAdmin = '[AgencyAdmin]',
  Partner = '[Partner]',
  ImmigrationProvider = '[ImmigrationProvider]',
  Unknown = '[Unknown]',
}

export enum UploadFileStatus {
  AWAITING = 'AWAITING',
  UPLOADING = 'UPLOADING',
  ERROR = 'ERROR',
  OK = 'OK',
}

export interface IModal {
  isFollowUpDocumentModal?: boolean;
  isFinanceDocumentModal?: boolean;
  isInterviewDocumentModal?: boolean;
  isRecordedInterviewDocumentModal?: boolean;
  isFollowUpModal?: boolean;
  sponsorType?: string;
  docType?: string | null;
  isComplete?: boolean | null;
  biometricResidencePermit?: BiometricResidencePermitDoc | null;
  sponsorKey?: string;
  docKey?: string | null;
  interviewType?: string;
  eventType?: string;
  eventKey?: string;
  interviewHash?: string;
  attemptHash?: string;
  modalTitle?: string;
  fileNames?: string[];
  isUpload?: boolean;
  shouldShowRequirements?: boolean;
  isInfoOnly?: boolean;
}

export interface IDate {
  DD: string | null;
  MM: string | null;
  YYYY: string | null;
  [index: string]: string | null;
}

export interface ICheckbox {
  id: string;
  label: string;
  subLabel?: string;
  isTicked: boolean;
  readOnly?: boolean;
  value?: string;
}

export interface IQuestion {
  char: string;
  label: string;
  labelHtml?: React.ReactNode;
  selected: boolean | undefined;
}

export interface ITBTestMetaData {
  isTBTestPending?: boolean;
  isReturningUKResident?: boolean;
  awayFromUKMoreThan2Yrs?: boolean;
  hasLivedInExemptCountry?: boolean;
  hasStayedInExemptCountry?: boolean;
}

export interface IStudentRefusalLetterMetaData {
  refusalDate?: string;
  applicationDate?: string;
  attendedInterview?: boolean;
  refusalGrounds?: RefusalGrounds[];
  refusalGroundsInfo?: string;
  appliedForAdminReview?: AppliedAdminReviewStatus;
  adminReviewDate?: string;
}

export interface IPhone {
  code: string | null;
  phone: string | null;
}

export interface CheckRadioGroupInfo {
  label: string | React.ReactElement;
  value: string;
  hint?: string;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  key?: string;
}
export interface ICheckRadioGroup extends CheckRadioGroupInfo {
  id?: string;
}

export interface GroupedCheckRadioGroupInfo {
  label: string | React.ReactElement;
  options: CheckRadioGroupInfo[];
}

export interface IOption {
  label: string;
  value: string;
  populate?: {
    options: IOption[];
  };
}

export interface ICardItem {
  label: string;
  value: ReactNode | string | number;
  required?: boolean;
}
